import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MemberListService } from '../../services/memberlist.service';

@Component({
  selector: 'app-authservice',
  templateUrl: './authservice.component.html',
  styleUrls: ['./authservice.component.css']
})
export class AuthserviceComponent implements OnInit {


  postData: any = {};

  constructor(private _memberListService: MemberListService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    var authToken = this.activatedRoute.snapshot.queryParamMap.get('code');
    this.postData.grant_type = "authorization_code";
    this.postData.client_id = "MEMBERALLYMOBILEAPP";
    this.postData.redirect_uri = "http://dev.memberally.prod.us.walmart.net/#/authservice/mobileapp";
    this.postData.code = authToken;
    var postDate = "code=" + authToken + "&grant_type=authorization_code&client_id=MEMBERALLYMOBILEAPP&redirect_uri=https://dev.memberally.prod.us.walmart.net/authservice/mobileapp"
    this._memberListService.callAuthService(postDate).subscribe((res: any) => {
     
    });
  }

}
